import { Box, Typography } from "@mui/material";
import NoResultsIllustration from "../../assets/icons/result.png"; 

export default function NoResults() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={5}
    >
      <img
        src={NoResultsIllustration}
        alt="Pas de résultat"
        style={{ maxWidth: 500, width: "100%", marginBottom: 16 }}
      />
  
    </Box>
  );
}
